import { render, staticRenderFns } from "./BlockSimple.vue?vue&type=template&id=5fe29535&"
import script from "./BlockSimple.vue?vue&type=script&lang=js&"
export * from "./BlockSimple.vue?vue&type=script&lang=js&"
import style0 from "./BlockSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports